import { ChipButtonsListSection } from "./ChipButtonsList";
import { usePollOptionsState } from "../PollOptionsState";
import { PollTypesEnum } from "../../../../../Shared/Types/Polls";
import { SquarePollSolidIcon } from "@icons/SquarePollSolidIcon";
import { SquareQuestionSolidIcon } from "@icons/SquareQuestionSolidIcon";
import { SliderSolidIcon } from "@icons/SliderIcon";
import { Grid2Icon } from "@icons/Grid2Icon";

export function ChoosePollTypeSection({
    allowPollEdit,
}: {
    allowPollEdit: boolean;
}) {
    const { pollType, updatePollType } = usePollOptionsState();

    const items = [
        {
            label: "Liste",
            isSelected:
                pollType === PollTypesEnum.POLL_VISIBLE ||
                pollType === PollTypesEnum.POLL_HIDDEN,
            onClick: () => updatePollType(PollTypesEnum.POLL_HIDDEN),
            icon: <SquarePollSolidIcon />,
        },
        {
            label: "Bilder",
            isSelected: pollType === PollTypesEnum.POLL_IMAGES,
            onClick: () => updatePollType(PollTypesEnum.POLL_IMAGES),
            icon: <Grid2Icon />,
        },
        {
            label: "Quiz",
            isSelected: pollType === PollTypesEnum.POLL_QUIZ,
            onClick: () => updatePollType(PollTypesEnum.POLL_QUIZ),
            icon: <SquareQuestionSolidIcon />,
        },
        {
            label: "Slider",
            isSelected: pollType === PollTypesEnum.POLL_RATING,
            onClick: () => updatePollType(PollTypesEnum.POLL_RATING),
            icon: <SliderSolidIcon />,
        },
    ];

    return (
        <ChipButtonsListSection
            sectionTitle="Wie soll abgestimmt werden?"
            items={items}
            allowPollEdit={allowPollEdit}
        />
    );
}
